export default "<div class='container-fluid'>\n    <img src=\"assets/images/icon/summa.png\" />\n</div>"